import { useState } from 'react';
import { Edit2, Trash2 } from 'lucide-react';

import { useDeleteCategory } from '@/api/category/use-delete-category.ts';
import type { CategoryDto } from '@/api/types';
import ConfirmModal from '@/components/confirm-modal/confirm-modal.tsx';
import { Button } from '@/components/ui/button.tsx';

type CategoryBoxViewProps = {
  projectId: string;
  category: CategoryDto;
  onEditClick: () => void;
};

const CategoryBoxView = ({ projectId, category, onEditClick }: CategoryBoxViewProps) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const { mutateAsync: deleteCategory, isPending } = useDeleteCategory(projectId!);

  const handleConfirmDelete = () => {
    deleteCategory(category.uuid).catch(() => undefined);
  };

  return (
    <>
      <span className="font-medium">{category.name}</span>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" onClick={onEditClick} className="h-8 w-8">
          <Edit2 className="size-3.5" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setConfirmDelete(true)}
          className="h-8 w-8 text-destructive hover:text-destructive"
          disabled={isPending}
        >
          <Trash2 className="size-3.5" />
        </Button>
      </div>
      {confirmDelete && (
        <ConfirmModal
          title="Delete category?"
          confirmLabel="Delete"
          onClose={() => setConfirmDelete(false)}
          onConfirm={handleConfirmDelete}
        >
          After deleting all expenses bound to category will be unassigned and needs to be updated
          manually to different category.
        </ConfirmModal>
      )}
    </>
  );
};

export default CategoryBoxView;
